import deepmerge from "deepmerge";

// Obtener oferta
const oferta = require(`./${_BBVA_MOTOR}.js`).default;
const ofertaDigital = require(`./ofertaDigital.js`).default;

const overwriteMerge = (destinationArray, sourceArray) => sourceArray;
export default deepmerge(ofertaDigital, oferta, { arrayMerge: overwriteMerge });
